import React from 'react';

import './components.scss';

const LevelBar = ({
  level = 2,
  changeAnswerValue = () => {},
  levels = [
    'None',
    'Minimal',
    'Medium',
    'Comprehensive',
    'Completely Comprehensive',
  ],
}) => {
  const onEachSegmentChange = (l) => () => {
    changeAnswerValue(l + 1);
  };
  const activeSegmentLength = (640 / (levels.length - 1)) * level;
  return (
    <div className="level-bar-wrapper">
      <span
        className="appkiticon icon-downtrend-fill"
        style={{ left: `${activeSegmentLength}px` }}
      />
      <div className="bar-base" />
      <div className="segment-group">
        {levels.map((_, i) => (
          <div className="divider-wrapper" key={`segment-${i}-divider`}>
            <div className="verticle-divider" />
          </div>
        ))}
      </div>
      <div className="segment-group">
        {levels.map((e, i) => (
          <div
            className="segment-div"
            key={`segment-${i}`}
            onClick={onEachSegmentChange(i)}
          >
            <div className={`segment-text ${level === i ? 'active-text' : ''}`}>
              {e}
            </div>
          </div>
        ))}
      </div>
      <div
        className="active-bar"
        style={{ width: `${activeSegmentLength}px` }}
      />
      <div
        className="active-verticle-divider"
        style={{ left: `${activeSegmentLength}px` }}
      />
    </div>
  );
};

export default LevelBar;
